import ReactDOM from 'react-dom/client';
import zhCN from 'antd/locale/zh_CN';
import { ConfigProvider, message } from 'antd';
import { Provider } from 'react-redux'
import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../src/icons/index';
import { store } from './store'
import * as buffer from "buffer";
import './antd.less'

message.config({
  duration: 2, // 默认的自动关闭时间（单位：秒）
  maxCount: 1
})

if (typeof (window as any).Buffer === "undefined") {
  (window as any).Buffer = buffer.Buffer;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN} >
      <App />
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
